import { post, put } from 'core_main/request';

import { memoize, memStore } from 'helpers/async-memoize';
import {
  InitAssistantParameters,
  SendKbDeflectionClickParameters,
} from './types';
import {
  validateInitAssistantParams,
  makeInitAssistantEndpoint,
  assistantStore,
  makeAssistantKbArticleDeflectionEndpoint,
} from './helpers';

const initAssistantApiCall = (parameters: InitAssistantParameters) => {
  const validationError = validateInitAssistantParams(parameters);

  if (validationError) {
    return Promise.reject(validationError);
  }

  const { assistant, dialog, assistantOptions } = parameters;

  const payload = {
    assistant,
    dialog,
  };
  const payloadRes = assistantOptions?.emulation
    ? { ...payload, assistantOptions }
    : payload;

  return post(makeInitAssistantEndpoint(parameters), {
    body: JSON.stringify(payloadRes),
  });
};
export const initAssistant = memoize(
  initAssistantApiCall,
  memStore(assistantStore),
);

export const sendKbDeflectionClickApiCall = (
  parameters: SendKbDeflectionClickParameters,
) => {
  return put(makeAssistantKbArticleDeflectionEndpoint(parameters.sessionId), {
    body: JSON.stringify({ articles: parameters.articles }),
  });
};
